import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userSubscription from './userSubscription';

export const list = createAsyncThunk(
  "user-subscription/list",
  async (params, thunkAPI) => {
    try {
      return await userSubscription.list(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const listUserSubscriptionPayments = createAsyncThunk(
  "user-subscription/list-user-subscription-payments",
  async (params, thunkAPI) => {
    try {
      return await userSubscription.listUserSubscriptionPayments(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const listUserRedeemCodes = createAsyncThunk(
  "user/list-user-redeem-code",
  async (params, thunkAPI) => {
    try {
      return await userSubscription.listUserRedeemCode(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const listUserCreditUsed = createAsyncThunk(
  "user/list-user-credit-used",
  async (params, thunkAPI) => {
    try {
      return await userSubscription.listUserCreditUsed(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const listLogsUserShot = createAsyncThunk(
  "user/list-logs-user-shot",
  async (params, thunkAPI) => {
    try {
      return await userSubscription.listLogsUserShot(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  userSubscriptions: [],
  userSubscriptionPayments: [],
  userRedeemCodes: [],
  userCreditUsages: [],
  logsUserShot: [],
  total: 0,
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updatingStatus: false,
  loadingDashboard: false,
};
export const userSubscriptionSlice = createSlice({
  name: "userSubscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(list.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(list.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.userSubscriptions = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(list.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(listUserSubscriptionPayments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listUserSubscriptionPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.userSubscriptionPayments = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(listUserSubscriptionPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(listUserRedeemCodes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listUserRedeemCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.userRedeemCodes = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(listUserRedeemCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(listUserCreditUsed.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listUserCreditUsed.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.userCreditUsages = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(listUserCreditUsed.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(listLogsUserShot.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listLogsUserShot.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.logsUserShot = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(listLogsUserShot.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
  },
});
export default userSubscriptionSlice.reducer;
